import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-days-of-week-selector',
    imports: [CommonModule],
    templateUrl: './days-of-week-selector.component.html',
    styleUrl: './days-of-week-selector.component.scss'
})
export class DaysOfWeekSelectorComponent {

  @Input() selectedDay: number = 1; // Lunes por defecto
  @Output() daySelected = new EventEmitter<number>();

  daysOfWeek = [
    { index: 0, label: 'Lunes', value: 1, short: 'L' },
    { index: 1, label: 'Martes', value: 2, short: 'M' },
    { index: 2, label: 'Miércoles', value: 4, short: 'X' },
    { index: 3, label: 'Jueves', value: 8, short: 'J' },
    { index: 4, label: 'Viernes', value: 16, short: 'V' },
    { index: 5, label: 'Sábado', value: 32, short: 'S' },
    { index: 6, label: 'Domingo', value: 64, short: 'D' }
  ];

  selectDay(dayValue: number): void {
    this.daySelected.emit(dayValue);
  }

}
